export default __webpack_public_path__ + "static/media/15.314e27d4.png";